import { useMemo } from 'react'
import { useNavigateTo } from 'infrastructure/routing'

export function useResourceRoutes(resource: string) {
  return useMemo(() => {
    return {
      show: (resourceId: string | number) => `/${resource}/${resourceId}/show`,
      create: `/${resource}/create`,
    }
  }, [resource])
}

export function useResourceNavigate(resource: string) {
  const navigate = useNavigateTo()
  const routes = useResourceRoutes(resource)
  return useMemo(() => {
    const { show, create } = routes
    return {
      show: (resourceId: string | number) => navigate(show(resourceId)),
      create: () => navigate(create),
    }
  }, [navigate, routes])
}
